import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { SEO } from "../components/SEO";
import { Reveal } from "../components/Reveal";

export default function Journal() {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    api.get("/journal").then((r) => setArticles(r.data.articles)).catch(() => setArticles([]));
  }, []);

  return (
    <main data-testid="journal-page" className="mx-auto max-w-7xl px-5 pb-24 pt-32 sm:px-8">
      <SEO title="Journal" path="/journal"
           description="Le journal de La Console des Artistes : morceaux de la semaine, portraits d'artistes et conseils pour sonoriser vos images." />
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-amber-500">Journal</p>
        <h1 className="mt-3 font-display text-4xl font-black tracking-tighter sm:text-6xl">
          Actualités & <span className="text-outline">conseils</span>
        </h1>
        <p className="mt-4 max-w-2xl text-base text-zinc-400">
          Morceaux de la semaine, portraits d'artistes et conseils pour bien choisir la musique de vos images.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {articles === null && <p className="text-sm text-zinc-500">Chargement…</p>}
        {articles?.length === 0 && (
          <p className="text-sm text-zinc-500" data-testid="journal-empty">
            Les premiers articles arrivent très bientôt.
          </p>
        )}
        {articles?.map((a) => (
          <Link key={a.content_id} to={`/journal/${a.content_id}`} data-testid={`journal-card-${a.content_id}`}
                className="group border border-white/[0.08] bg-surface transition-colors hover:border-amber-500/50">
            <div className="aspect-[1200/630] overflow-hidden bg-black">
              <img src={a.image_url} alt={a.title} loading="lazy"
                   className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-5">
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-500">{a.theme_label}</p>
              <h2 className="mt-2 font-display text-lg font-medium leading-snug group-hover:text-amber-400">{a.title}</h2>
              {a.excerpt && <p className="mt-2 text-sm text-zinc-500">{a.excerpt}</p>}
              <p className="mt-3 text-[10px] uppercase tracking-[0.2em] text-zinc-600">
                {new Date(a.published_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}
